import { useEffect, useCallback, useRef, useState } from "react";
import { apiGet } from "../lib/api";

const POLL_INTERVAL_MS = 2500;
const MAX_POLL_ATTEMPTS = 12;
const SUCCESS_REDIRECT_DELAY_MS = 1200;

/**
 * usePaymentPolling — encapsulates the Stripe-checkout success-polling logic
 * used on the Premium page. Reads `?txn=...` from URL, polls /checkout/status
 * every 2.5s up to 12 times, refreshes auth on success, navigates to dashboard.
 *
 * Returns: { polling, statusMsg }
 */
export default function usePaymentPolling({ params, refresh, navigate }) {
  const [polling, setPolling] = useState(false);
  const [statusMsg, setStatusMsg] = useState("");
  const startedRef = useRef(false);

  const poll = useCallback(async (txnId, attempts = 0) => {
    if (attempts >= MAX_POLL_ATTEMPTS) {
      setPolling(false);
      setStatusMsg("Verifica scaduta. Se hai pagato, attendi qualche minuto e ricarica la pagina.");
      return;
    }
    try {
      const r = await apiGet(`/checkout/status/${txnId}`);
      if (r.payment_status === "paid") {
        setPolling(false);
        setStatusMsg("Pagamento riuscito! Abbonamento attivato.");
        await refresh();
        setTimeout(() => navigate("/dashboard"), SUCCESS_REDIRECT_DELAY_MS);
        return;
      }
      setStatusMsg("In attesa di conferma da Stripe...");
      setTimeout(() => poll(txnId, attempts + 1), POLL_INTERVAL_MS);
    } catch {
      setPolling(false);
      setStatusMsg("Errore nella verifica.");
    }
  }, [refresh, navigate]);

  useEffect(() => {
    const tid = params.get("txn");
    if (tid && !startedRef.current) {
      startedRef.current = true;
      setPolling(true);
      poll(tid);
    }
  }, [params, poll]);

  return { polling, statusMsg };
}
